import * as React from 'react';
import ReactTable from 'react-table';
import { Button, Form, Label, Modal } from 'semantic-ui-react';
import 'react-table/react-table.css';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';
import AddEditWindow from './addEditWindow';
// import { default as Renderers } from '../../../sys/columns';
const FontAwesome = require('react-fontawesome');

class State {
    data: any;
    window: string;
    showAddEditWindow: boolean;
    selectedRow ?: any;
    showModal ?: boolean;
    ldapEnabled: boolean;
}

interface Props {

}

export default class UserAccountsViewPanel extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            data: '',
            window: 'Add',
            showAddEditWindow: false,
            selectedRow: '',
            showModal: false,
            ldapEnabled: false
        });
        this.fetchUsers();
        this.isLdapEnabled();
        this.deleteUser = this.deleteUser.bind(this);
        this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
        this.setUsersDisabled = this.setUsersDisabled.bind(this);

    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const columns = [{
            width: 15
        }, {
            width: 55,
            Cell: (props: any) => this.buttonRenderer(props)
        }, {
            Header: 'User Name',
            accessor: 'name',
            headerStyle: { textAlign: 'left' },
            // getProps: (rowInfo: any) => {
            //     console.log(rowInfo);
            //     return {
            //         style: {
            //             color: rowInfo  && this.state.ldapEnabled  ? "red" : "black",
            //         },
            //     };
            // },
            width: 190
        }, {
            Header: 'User Role',
            accessor: 'accessLevel',
            headerStyle: { textAlign: 'left' },
            width: 150,
            Cell: (props: any) => this.userRoleRenderer(props)
        }, {
            Header: 'Expiration Rule',
            accessor: 'expiryRule',
            headerStyle: { textAlign: 'left' },
            width: 190
        }, {
            Header: 'Next Expiration',
            accessor: 'nextExpiration',
            headerStyle: { textAlign: 'left' },
            width: 220,
            Cell: (props: any) => this.nextExpiryRenderer(props),
        }, {
            Header: 'Last Login',
            accessor: 'lastLogin',
            headerStyle: { textAlign: 'left' },
            width: 220
            // Cell: (props: any) => Renderers.timestamp.format(props.value),
        }];

        return(
            <div className="view-content" id="txlog">
                {/*<div className="pageTitle">*/}
                {/*    <div className="page-title-block">*/}
                {/*        <div className="iq-temp-key-val">*/}
                {/*            <div className="iq-temp-val page-title-text">User Administration</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="filterPanel">
                    <Label className="system-config-pageHeader">
                        User Administration
                    </Label>
                    {this.state.ldapEnabled ? <span className={`ldap-check ldap-check-enabled`}>LDAP authentication is configured and user accounts are not managed on this panel.</span> : null}
                    <Button
                        className="filterPanel-right-primary-btn"
                        content="Add User"
                        disabled={this.state.ldapEnabled}
                        onClick={(event, data) => this.addUser()}
                    />
                </div>
                <div className="view-clientarea">
                    <ReactTable
                        className="transaction-log -striped -highlight"
                        onFetchData={() => this.fetchUsers()}
                        data={(this.state && this.state.data) ? this.state.data : []}
                        columns={columns}
                        defaultPageSize={15}
                        showPagination={false}
                        getTrProps={this.getTrProps}
                    />
                    <AddEditWindow
                        title={(this.state.window === 'Add') ? 'Add User' : 'Edit User'}
                        showModal={this.state.showAddEditWindow}
                        handleModalClose={() => this.handleModalClose()}
                        selectedRow={this.state.selectedRow}
                        fetchUsers={() => this.fetchUsers()}
                    />
                    <Modal
                        open={this.state.showModal}
                        onClose={this.handleDeleteModalClose}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>Delete User</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    Are you sure you want to delete this user?
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                className="filterPanel-secondary-btn modal-button-padding"
                                onClick={this.deleteUser}
                            >
                                Yes
                            </Button>
                            <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleDeleteModalClose}>
                                No
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }
    handleDeleteModalClose() {
        this.setState({
            showModal: false
        });
    }
    userRoleRenderer(props: any) {
        if (props.value === 'public') {
            return 'user';
        } else if (props.value === 'private') {
            return '';
        }
        return props.value;
    }

    nextExpiryRenderer(props: any) {
        if (props.value === 0 && props.original.expiryRule !== 'never') {
            return 'Expired';
        } else if (props.value !== 0) {
            return props.value;
        }
    }
    handleModalClose() {
        this.setState({
            showAddEditWindow: false
        });
    }
    addUser() {
        this.setState({
            window: 'Add',
            showAddEditWindow: true,
            selectedRow: null
        });
    }

    editUser(props: any) {
        this.setState({
            window: 'Edit',
            showAddEditWindow: true,
            selectedRow: props.original
        });
    }

    deleteUser() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/config/users/' + this.state.selectedRow.original.name;

        axios.delete(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    __this.fetchUsers();
                    __this.handleDeleteModalClose();
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('edit user error, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('edit user error, got: ', error);
            });
    }

    buttonRenderer(props: any): React.ReactNode {

        return (
            <div className="cellIcons">
                <Button
                    className="grid-hamburger-menu-button"
                    disabled={props.original.name !== 'Admin' && this.state.ldapEnabled}
                    title="Edit User"
                    onClick={(event, data) => this.editUser(props)}
                >
                    <FontAwesome name="far fa-edit"/>
                </Button>
                <Button
                    className="grid-hamburger-menu-button iconSpacing"
                    disabled={props.original.name !== 'Admin' && this.state.ldapEnabled}
                    title="Delete User"
                    onClick={(event, data) => this.setState({selectedRow: props, showModal: true})}
                >
                    <FontAwesome name="fas fa-trash-o"/>
                </Button>
            </div>

        );
    }
    fetchUsers() {
        let _this = this;
        let url = 'http://default/api/config/users';
        axios.get(url, {headers: {'x-orderby': 'order users by name asc'}})
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    _this.setState({
                        data: response.data.users
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of users, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchUsers() error: ', error);
            });
    }
    isLdapEnabled() {
        let _this = this;
        let url = 'http://default/api/config/ldap/enableLdap';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    _this.setState({
                        ldapEnabled: response.data.value
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of users, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('isLdapEnabled() error: ', error);
            });

    }
    setUsersDisabled() {
        let newData = this.state.data.map((usr: any) => (
            (this.state.ldapEnabled && usr.name !== 'Admin') ? {...usr, enabled: false} : {...usr}
        ));

        this.setState({
            data: newData
        });
    }

    /* Sets the opacity for the rows to appear disabled if LDAP is enabled and the access level is not admin*/
    getTrProps = (state: any, rowInfo: any, instance: any) => {
        if (rowInfo) {
            return {
                style: {
                    opacity: rowInfo.row.name !== 'Admin' && this.state.ldapEnabled  ? 0.35 : 1,
                }
            };
        }
        return {};
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/security/userAccounts.tsx